import { render, staticRenderFns } from "./gift-card-detail-page.vue?vue&type=template&id=2dff7df7&scoped=true&lang=html&"
import script from "./gift-card-detail-page.vue?vue&type=script&lang=js&"
export * from "./gift-card-detail-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff7df7",
  null
  
)

export default component.exports